module.exports = __webpack_public_path__ + "img/shipping-unchecked.07b71fbe.svg";